const personalInformation = {
  path: 'personalInformation',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/personalInformation'], resolve)
}
export default personalInformation
